import React from 'react';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { ISellerItem } from '../../../modules/API/Defaults/models/seller';
import CoinIcon from '../../icons/IconLib/CoinIcon';

interface Props {
    sellers: ISellerItem[];
    value: ISellerItem | null;
    onSelect: (seller: ISellerItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    allowClear?: boolean;
    clearLabel?: string;
    className?: string;
}

const SellerSelector: React.FC<Props> = ({
    sellers,
    value,
    onSelect,
    placeholder = 'בחר משווק',
    disabled,
    readOnly,
    allowClear,
    clearLabel = 'הכל',
    className,
}) => (
    <SearchableSelect<ISellerItem>
        items={sellers}
        value={value}
        onSelect={onSelect}
        getKey={(s) => s.SellerID}
        getLabel={(s) => (s.Seller_Desc ?? '').trim()}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        allowClear={allowClear}
        clearLabel={clearLabel}
        leadingIcon={<CoinIcon />}
        className={className}
        emptyLabel='אין משווקים מתאימים'
    />
);

export default SellerSelector;
